const LibyaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111774)">
      <path
        d="M1.98453 11.3046C0.713125 13.9339 0 16.8837 0 20.0002C0 23.1167 0.713125 26.0664 1.98453 28.6958L20 30.435L38.0155 28.6958C39.2869 26.0664 40 23.1167 40 20.0002C40 16.8837 39.2869 13.9339 38.0155 11.3046L20 9.56543L1.98453 11.3046Z"
        fill="black"
      />
      <path
        d="M1.98486 28.6953C5.21971 35.3852 12.0704 39.9997 19.9996 39.9997C27.9288 39.9997 34.7795 35.3852 38.0144 28.6953H1.98486Z"
        fill="#496E2D"
      />
      <path
        d="M1.98486 11.3044H38.0144C34.7795 4.61445 27.9288 0 19.9996 0C12.0704 0 5.21971 4.61445 1.98486 11.3044Z"
        fill="#D80027"
      />
      <path
        d="M24.6541 16.3428L26.295 18.6041L28.9526 17.7424L27.309 20.0018L28.9498 22.263L26.2932 21.398L24.6496 23.6574L24.6513 20.8636L21.9946 19.9986L24.6523 19.1368L24.6541 16.3428Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.1763 25.6517C17.0547 25.6517 14.5241 23.1211 14.5241 19.9995C14.5241 16.878 17.0547 14.3473 20.1763 14.3473C21.1496 14.3473 22.0654 14.5934 22.865 15.0267C21.6106 13.8001 19.8953 13.043 18.0024 13.043C14.1604 13.043 11.0459 16.1575 11.0459 19.9995C11.0459 23.8414 14.1604 26.9559 18.0024 26.9559C19.8954 26.9559 21.6107 26.1988 22.865 24.9722C22.0654 25.4056 21.1496 25.6517 20.1763 25.6517Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111774">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LibyaSvg;
